module.exports = __webpack_public_path__ + "static/media/menu-white.edfacd5c.svg";